import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BAJournalismMassCommCoursePage: React.FC = () => {
  const courseData = {
    title: "B.A. Journalism and Mass Communication",
    shortName: "B.A. JMC",
    duration: "3 years",
    description: "Study of media, journalism, and mass communication in digital age",
    overview: "Bachelor of Arts in Journalism and Mass Communication is a 3-year undergraduate program that covers various aspects of media and communication including print journalism, broadcast media, digital media, public relations, and advertising. This course develops skills in news writing, reporting, media production, and communication strategy, preparing students for diverse careers in the rapidly evolving media landscape.",
    eligibility: [
      "10+2 in any stream",
      "Minimum 50% marks in 12th standard",
      "Good command over English language",
      "Interest in current affairs and communication"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Introduction to Journalism",
          "Mass Communication Theory",
          "News Writing and Reporting",
          "English Language Skills",
          "History of Journalism",
          "Computer Applications"
        ]
      },
      {
        year: 2,
        subjects: [
          "Print Journalism",
          "Radio and Television Production",
          "Advertising and Public Relations",
          "Media Law and Ethics",
          "Development Communication",
          "Photography and Visual Communication"
        ]
      },
      {
        year: 3,
        subjects: [
          "Digital Journalism",
          "Media Management",
          "Documentary Production",
          "International Communication",
          "Media Research",
          "Internship and Project Work"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Journalist/Reporter",
        "News Anchor",
        "Content Writer",
        "Public Relations Officer",
        "Digital Marketing Executive",
        "Social Media Manager",
        "Documentary Filmmaker",
        "Radio Jockey",
        "Copywriter",
        "Media Researcher"
      ],
      industries: [
        "Print Media",
        "Television Networks",
        "Radio Stations",
        "Digital Media Platforms",
        "Advertising Agencies",
        "Public Relations Firms",
        "Corporate Communications",
        "Film and Entertainment",
        "Government Communications",
        "Online Publications"
      ],
      averageSalary: "₹3-8 LPA (Fresher), ₹12-35 LPA (Experienced)",
      topRecruiters: [
        "Times Group, Hindustan Times",
        "Star India, Zee Entertainment",
        "NDTV, CNN-News18",
        "Ogilvy, JWT, McCann",
        "Facebook, Google, Twitter",
        "Government Press Information"
      ]
    },

    admissionProcess: [
      "Merit-based admission on 12th marks",
      "Entrance tests in some colleges",
      "Group discussion and interview",
      "Portfolio submission (for some courses)",
      "English proficiency test"
    ],

    topColleges: [
      {
        name: "Loyola College",
        location: "Chennai",
        fees: "₹60,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "Women's Christian College",
        location: "Chennai",
        fees: "₹45,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "PSG College of Arts and Science",
        location: "Coimbatore",
        fees: "₹50,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Annamalai University",
        location: "Chidambaram",
        fees: "₹40,000",
        ranking: "State University"
      }
    ],

    skills: [
      "News Writing and Reporting",
      "Video and Audio Production",
      "Social Media Management",
      "Content Creation",
      "Interview Techniques",
      "Research and Fact-checking",
      "Public Speaking",
      "Digital Marketing",
      "Media Planning",
      "Crisis Communication"
    ],

    futureScope: "Excellent growth prospects with digital media revolution, social media journalism, podcasting, content marketing, and emerging technologies like AI in media creating new opportunities.",

    faqs: [
      {
        question: "What are the current trends in journalism and mass communication?",
        answer: "Digital journalism, social media reporting, data journalism, podcast production, influencer marketing, and AI-assisted content creation are major current trends in the field."
      },
      {
        question: "Can I work as a freelancer in this field?",
        answer: "Yes, there are excellent freelancing opportunities in content writing, social media management, video production, journalism, and digital marketing consulting."
      },
      {
        question: "Is this course suitable for starting a media business?",
        answer: "Absolutely! The course provides comprehensive knowledge of media operations, content creation, and audience engagement essential for starting digital media ventures or content agencies."
      },
      {
        question: "What role does technology play in modern journalism?",
        answer: "Technology is central to modern journalism with digital platforms, social media, live streaming, data analytics, and AI tools transforming how news is gathered, produced, and consumed."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BAJournalismMassCommCoursePage;
